export const ASSET_IMAGES = {
  heroWater: '/images/hero_water_purification_plant_1791634079237.jpg',
  milkAtm: '/images/product_milk_atm_dispenser_1791634089688.jpg',
  waterStation: '/images/product_water_vending_station_1791634099673.jpg',
  milkPasteurizer: '/images/product_milk_pasteurizer_tank_1791634110703.jpg',
  cookingOil: '/images/product_cooking_oil_atm_1791634122585.jpg',
  blogKenyanMarkets: '/images/blog_kenyan_commercial_markets_1792151577662.jpg',
  blogDairyFarming: '/images/blog_dairy_farming_milk_atm_1792151579420.jpg',
  blogCleanWater: '/images/blog_clean_water_purification_1792151579578.jpg',
  blogFreshMilkOnTap: '/images/blog_fresh_milk_on_tap_1792151579386.jpg',
};

/**
 * Robust image URL resolver that guarantees a working image URL
 * in development, local preview, and production builds.
 */
export function resolveImageUrl(pathOrUrl?: string, fallbackCategory?: string): string {
  if (!pathOrUrl || typeof pathOrUrl !== 'string') {
    return getFallbackByCategory(fallbackCategory);
  }

  const trimmed = pathOrUrl.trim();
  if (!trimmed) {
    return getFallbackByCategory(fallbackCategory);
  }

  // If already an inline Data URI or Blob URL
  if (trimmed.startsWith('data:') || trimmed.startsWith('blob:')) {
    return trimmed;
  }

  // If it's an external URL (e.g. from user input or CDN)
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }

  // If it's a dedicated uploaded image path
  if (trimmed.startsWith('/uploads/')) {
    return trimmed;
  }

  // Strip leading /src/assets/images/ or /public/ to map to local public assets
  if (trimmed.startsWith('/src/assets/images/')) {
    const filename = trimmed.replace('/src/assets/images/', '');
    return `/images/${filename}`;
  }

  if (trimmed.startsWith('/public/')) {
    return trimmed.replace('/public/', '/');
  }

  // If already starts with /
  if (trimmed.startsWith('/')) {
    return trimmed;
  }

  // Fallback to category default
  return getFallbackByCategory(fallbackCategory);
}

export function getFallbackByCategory(category?: string): string {
  switch (category) {
    case 'milk-atm':
      return ASSET_IMAGES.milkAtm;
    case 'pasteurizers':
      return ASSET_IMAGES.milkPasteurizer;
    case 'water-vending':
      return ASSET_IMAGES.waterStation;
    case 'cooking-oil':
      return ASSET_IMAGES.cookingOil;
    case 'water-purification':
    case 'spares':
    default:
      return ASSET_IMAGES.heroWater;
  }
}
